import React, { useState } from 'react';
import { Image, Pressable, useWindowDimensions, View } from 'react-native';
import dependencies from '@/assets/dependencies.json';
import { TextLink } from '@/components/TextLink';
import { Text } from '@/components/Text';
import { Icon } from '@/components/Icon';
import colors from '@/config/colors';
import { BodyWrapper } from '@/layouts/BodyWrapper';

import constants from '@/config/constants';
import { Card } from '@/components/ui/therapist/Card';
import { styles } from '@/screens/TherapistSettings/AboutNeolexon/styles';
import { Links } from '@/config/links';

export function AboutNeolexon() {
  const [expanded, setExpanded] = useState(false);
  const { width } = useWindowDimensions();
  const isSmallScreenSize = width < 550;
  const technicalDataCopy = [
    {
      leftText: 'App Version',
      rightText: constants.appVersion,
    },
    {
      leftText: 'UDI-DI',
      rightText: constants.udiDi,
    },
    {
      leftText: 'UDI-PI',
      rightText: constants.udiPi(),
    },
  ];

  return (
    <BodyWrapper>
      <View>
        <Card
          styleBody={{ paddingHorizontal: 0, paddingBottom: 0 }}
          title="Technischen Daten"
        >
          {technicalDataCopy.map((textMap, idx) => (
            <View
              key={idx}
              style={[styles.technicalTextWrapper, styles.borderStyle]}
            >
              <Text>{textMap.leftText}</Text>
              <Text>{textMap.rightText}</Text>
            </View>
          ))}
        </Card>
        <Card title="Über neolexon">
          <Text>
            neolexon ist ein digitales Unterstützungssystem für die
            Sprachtherapie und ist als Medizinprodukt eingetragen. Das Projekt
            neolexon ist eine Ausgründung der Entwicklungsgruppe Klinische
            Neuropsychologie des Instituts für Phonetik und Sprachverarbeitung,
            Ludwig-Maximilians-Universität München. Ein interdisziplinäres Team
            aus Sprachtherapeut: innen und Informatiker:innen ist für die
            {'\n'}
            Entwicklung von neolexon verantwortlich. Das Feedback von
            Patient:innen und Therapeut:innen wird stets in die
            Weiterentwicklung von neolexon mit einbezogen.
          </Text>
        </Card>
        <Card title="Zweckbestimmung">
          <View
            style={{
              display: 'flex',
              flexDirection: isSmallScreenSize ? 'column' : 'row',
            }}
          >
            <Text style={{ flexShrink: 1 }}>
              neolexon Aphasie bietet eine digitale Sprachtherapie für
              Patient:innen mit Aphasie und/oder Sprechapraxie, die aufgrund
              einer neurologischen Erkrankung sprachliche Beeinträchtigungen
              haben. Die digitale Anwendung soll die logopädische Therapie
              zielgerichtet intensivieren und die sprachlichen Fähigkeiten
              verbessern. neolexon Aphasie ist nur anwendbar als Ergänzung zur
              Behandlung bei Logopäd:innen/Sprachtherapeut:innen. Die Anwendung
              ist nicht dafür bestimmt, Informationen für diagnostische oder
              therapeutische Entscheidungen zu liefern.
            </Text>
            <View
              style={[
                { marginTop: 'auto' },
                isSmallScreenSize
                  ? { paddingTop: 16, paddingLeft: 0 }
                  : { paddingTop: 0, paddingLeft: 8 },
              ]}
            >
              <View style={{ width: 48, height: 32 }}>
                <Image
                  style={{ width: '100%', height: '100%' }}
                  resizeMode="contain"
                  source={require('@/assets/ce4.png')}
                />
              </View>
            </View>
          </View>
        </Card>
        <Card styleBody={{ padding: 0 }}>
          <View style={{ padding: 16 }}>
            <Text style={styles.headerStyle}>Autorinnen von neolexon</Text>
            <Text>
              Dr. Mona Späth und Dr. Hanna Jakob, Sprachtherapeutinnen, M.A.,
              {'\n'}
              Geschäftsführung Limedix GmbH
            </Text>
          </View>
          <View style={styles.borderStyle}>
            <Text style={styles.headerStyle}>Datenschutz</Text>
            <Text>
              Datenschutz hat bei neolexon höchste Priorität. Die geltenden
              Datenschutzbestimmungen nach DSGVO und BDSG-neu werden
              eingehalten. Weitere Informationen finden Sie in unserer{' '}
              <TextLink href={Links.datenschutz.href}>
                Datenschutzerklärung
              </TextLink>
              .
            </Text>
          </View>
        </Card>
        <Card styleBody={{ padding: 0 }}>
          <View style={styles.borderStyle}>
            <Text style={styles.headerStyle}>
              Eingesetzte Software-Komponenten
            </Text>
            <Text>
              Im Folgenden finden Sie eine Übersicht der verwendeten
              Software-Komponenten von Drittanbietern. Diese sind erforderlich,
              um bestimmte Funktionen bereitzustellen und den sicheren und
              zuverlässigen Betrieb der Anwendung zu gewährleisten.
            </Text>
            <Pressable onPress={() => setExpanded((v) => !v)}>
              <View
                style={{
                  flexDirection: 'row',
                  alignItems: 'center',
                  paddingTop: 8,
                }}
              >
                <Text>{expanded ? 'Ausblenden' : 'Anzeigen'}</Text>
                <Icon
                  name={expanded ? 'chevronDown' : 'chevronRight'}
                  size={20}
                  color={colors.newUI.therapist.primaryBlue80}
                />
              </View>
            </Pressable>
            {expanded ? (
              <View style={{ marginTop: 8 }}>
                {dependencies.map((dep) => (
                  <Text key={dep}>
                    {'• '}
                    {dep}
                  </Text>
                ))}
              </View>
            ) : null}
          </View>
        </Card>
      </View>
    </BodyWrapper>
  );
}
